import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Templates() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notification-templates").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (t) => {
    await api.put(`/notification-templates/${t.key}`, t);
    toast.success("Template saved");
    load();
  };

  return (
    <Layout>
      <div className="fade-in space-y-4">
        <h1 className="text-2xl font-semibold tracking-tight" style={{fontFamily:'Outfit'}}>Notification templates</h1>
        <p className="text-slate-600 text-sm">Edit subject & body. Channels list determines which providers (email/SMS) will be used when wired up.</p>
        <div className="grid lg:grid-cols-2 gap-4">
          {items.map((t) => (
            <Card key={t.key} className="rounded-xl border-slate-200" data-testid={`template-${t.key}`}>
              <CardContent className="p-6 space-y-3">
                <div className="text-xs uppercase tracking-widest text-slate-500">{t.key}</div>
                <div>
                  <Label>Subject</Label>
                  <Input value={t.subject} onChange={(e)=>setItems(items.map(x => x.key===t.key ? {...x, subject: e.target.value}: x))} data-testid={`tpl-subject-${t.key}`}/>
                </div>
                <div>
                  <Label>Body</Label>
                  <Textarea rows={3} value={t.body} onChange={(e)=>setItems(items.map(x => x.key===t.key ? {...x, body: e.target.value}: x))} data-testid={`tpl-body-${t.key}`}/>
                </div>
                <div>
                  <Label>Channels (comma-separated: in_app, email, sms)</Label>
                  <Input value={(t.channels||[]).join(", ")} onChange={(e)=>setItems(items.map(x => x.key===t.key ? {...x, channels: e.target.value.split(',').map(s=>s.trim()).filter(Boolean)}: x))} data-testid={`tpl-channels-${t.key}`}/>
                </div>
                <Button onClick={() => save(t)} className="bg-blue-900 hover:bg-blue-800" data-testid={`tpl-save-${t.key}`}>Save</Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </Layout>
  );
}
